import { ReactNode, createContext, useContext, useMemo } from 'react';

type ManifestPreviewContextValue = {
  /** Triggers a fresh preview import fetch. */
  onRefreshPreview: () => void;
};

const ManifestPreviewContext = createContext<ManifestPreviewContextValue>({
  onRefreshPreview: () => {},
});

type ManifestPreviewProviderProps = {
  children: ReactNode;
  onRefreshPreview: () => void;
};

export const ManifestPreviewProvider = ({ children, onRefreshPreview }: ManifestPreviewProviderProps): JSX.Element => {
  const value = useMemo(() => ({ onRefreshPreview }), [onRefreshPreview]);
  return <ManifestPreviewContext.Provider value={value}>{children}</ManifestPreviewContext.Provider>;
};

export const useManifestPreviewContext = (): ManifestPreviewContextValue => useContext(ManifestPreviewContext);
